export const DOTCOM = 'dotcom';
export const TV_SERIES = 'tv-series';
export const WEB_ORIGINAL = 'web-original';



// WEBPACK FOOTER //
// ./src/show-page/constants/show-type.js